import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Observable, BehaviorSubject, Observer } from 'rxjs';
import { CandidateService } from '../candidate.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { auth } from 'firebase';
import { AuthService } from 'src/app/auth/auth.service';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { MatSnackBar, MatDialog } from '@angular/material';
import { scrollIntoView } from 'ng-zorro-antd';
import { CandidateData } from '../candidateData';
import { Router } from '@angular/router';

@Component({
  selector: 'app-create-profile',
  templateUrl: './create-profile.component.html',
  styleUrls: ['./create-profile.component.css'],
  providers: [PdfViewerComponent]
})
export class CreateProfileComponent implements OnInit {

  @Input() isEditProfile: boolean;
  @Input() data;
  @ViewChild('basicDetailsFormElement', { static: true }) basicDetailsFormElement;
  @ViewChild('skillsFormElement', { static: true }) skillsFormElement;
  @ViewChild('workExperienceFormElement', { static: true }) workExperienceFormElement;
  @ViewChild('educationalDetailsFormElement', { static: true }) educationalDetailsFormElement;
  @ViewChild('preferencesFormElement', { static: true }) preferencesFormElement;
  @ViewChild('profileLinksFormElement', { static: true }) profileLinksFormElement;

  //Production set
  // private formTwoSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  // public formTwo: Observable<boolean> = this.formTwoSubject.asObservable();
  // private formThreeSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  // public formThree: Observable<boolean> = this.formThreeSubject.asObservable();
  // private formFourSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  // public formFour: Observable<boolean> = this.formFourSubject.asObservable();
  // private formFiveSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  // public formFive: Observable<boolean> = this.formFiveSubject.asObservable();
  // private formSixSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  // public formSix: Observable<boolean> = this.formSixSubject.asObservable();
  // private formSevenSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  // public formSeven: Observable<boolean> = this.formSevenSubject.asObservable();
  // private formEightSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  // public formEight: Observable<boolean> = this.formEightSubject.asObservable();

  //Testing Set
  private formTwoSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public formTwo: Observable<boolean> = this.formTwoSubject.asObservable();
  private formThreeSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public formThree: Observable<boolean> = this.formThreeSubject.asObservable();
  private formFourSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public formFour: Observable<boolean> = this.formFourSubject.asObservable();
  private formFiveSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public formFive: Observable<boolean> = this.formFiveSubject.asObservable();
  private formSixSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public formSix: Observable<boolean> = this.formSixSubject.asObservable();
  private formSevenSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public formSeven: Observable<boolean> = this.formSevenSubject.asObservable();
  private formEightSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public formEight: Observable<boolean> = this.formEightSubject.asObservable();

  basicDetailsForm: FormGroup;
  resumeForm: FormGroup;
  workExperienceForm: FormGroup;
  educationalDetailsForm: FormGroup;
  profileLinksForm: FormGroup;
  skillsForm: FormGroup;
  preferencesForm: FormGroup;

  workExperience = [];
  educationalDetails = [];

  jobTypes;
  jobRoleExperienceList;
  experiences = ['0-1 years', '1-2 years', '2-4 years', '4-6 years', '6-10 years', '10-15 years', '15+ years']

  primarySkills = [];
  additionalSkills = [];
  preferenceLocations = []

  file: File;

  filterlocations:any = [];
  candidate_id:string;
  candidate_data:any = {}
  profile_url:string= "";
  editWorkExperience:any={index:null,flag:false}
  editEducationDetails:any={index:null,flag:false}
  showIncompleteMessage:boolean = false;
  no_experience = [];
 
  constructor(private router:Router,private fb: FormBuilder, private _formBuilder: FormBuilder, private candidateService: CandidateService, private storage: AngularFireStorage, private authService: AuthService, private _snackBar: MatSnackBar,private dialog: MatDialog) { }

  ngOnInit() {
    this.basicDetailsForm = this.fb.group({
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      email: [{ value: 'example@email.com', disabled: true }, [Validators.required]],
      mobileNumber: ['', [Validators.required]],
      location: ['', [Validators.required]],
      headline: ['', [Validators.required]],
      isActivelyLooking: [null, [Validators.required]],
      profileImage: [null]
    });

    this.skillsForm = this.fb.group({
      jobType: [null, [Validators.required]],
      totalExperience: [null, [Validators.required]],
      jobRoles: [null, [Validators.required]],
      primarySkills: [[], [Validators.required]],
      additionalSkills: [[]]
    })

    this.resumeForm = this.fb.group({
      resumeUrl: [null]
    })

    this.workExperienceForm = this.fb.group({
      title: [null, [Validators.required]],
      company: [null, [Validators.required]],
      duration: [null],
      startDate: [null],
      isCurrentlyWorking: [false],
      description: [null, [Validators.required]],
    })

    this.educationalDetailsForm = this.fb.group({
      universityName: [null, [Validators.required]],
      graduationYear: [null, [Validators.required]],
      degree: [null, [Validators.required]],
      fieldOfStudy: [null, [Validators.required]],
      instituteLocation: [null, [Validators.required]]
    })

    this.profileLinksForm = this.fb.group({
      githubUrl: [""],
      linkedInUrl: [""]
    })

    this.preferencesForm = this.fb.group({
      preferredLocation: [[], [Validators.required]],
      anyStateInUsa: [null, [Validators.required]],
      fullTime: this.fb.group({
        selected: [false, [Validators.required]],
        preferred_salary: [null, [Validators.required]],
        is_negotialble: [null, [Validators.required]]
      }),
      internship: this.fb.group({
        selected: [false, [Validators.required]],
        preferred_salary: [null, [Validators.required]],
        is_negotialble: [null, [Validators.required]]
      }),
      contractor: this.fb.group({
        selected: [false, [Validators.required]],
        preferred_salary: [null, [Validators.required]],
        is_negotialble: [null, [Validators.required]]
      })
    })
    this.viewIncompleteMessage();
    this.getCandidateDetails();
    
    this.workExperienceForm.get('isCurrentlyWorking').valueChanges.subscribe(val => {
      console.log(this.workExperienceForm.value.isCurrentlyWorking)
      if (this.workExperienceForm.value.isCurrentlyWorking) {
        this.workExperienceForm.controls.duration.setValidators(null)
        this.workExperienceForm.controls.startDate.setValidators([Validators.required])
      }
      else {
        this.workExperienceForm.controls.duration.setValidators([Validators.required])
        this.workExperienceForm.controls.startDate.setValidators(null)
      }
    });

    this.getJobTypes();
    this.candidateService.getSkills().subscribe(
      (data: any) => {
        if(typeof data == 'object'){
          this.primarySkills = data.skills;
          this.additionalSkills = data.skills;
        }
      }
    )
    this.candidateService.getPreferenceLocations().subscribe(
      (data: any) => {
        if(typeof data == 'object'){
          this.preferenceLocations = data.locations;
        }
      }
    )
  }

  basicFilter(){
    this.basicDetailsForm.controls.firstName.setValue(String(this.basicDetailsForm.value.firstName.trim().replace(/\s\s+/g, ' ')));
    this.basicDetailsForm.controls.lastName.setValue(String(this.basicDetailsForm.value.lastName.trim().replace(/\s\s+/g, ' ')));
    this.basicDetailsForm.controls.mobileNumber.setValue(String(this.basicDetailsForm.value.mobileNumber.trim().replace(/\s\s+/g, ' ')));
    this.basicDetailsForm.controls.location.setValue(String(this.basicDetailsForm.value.location.trim().replace(/\s\s+/g, ' ')));
    this.basicDetailsForm.controls.headline.setValue(String(this.basicDetailsForm.value.headline.trim().replace(/\s\s+/g, ' ')));
  }

  workFilter(){
    this.workExperienceForm.controls.title.setValue(String(this.workExperienceForm.value.title.trim().replace(/\s\s+/g, ' ')));
    this.workExperienceForm.controls.company.setValue(String(this.workExperienceForm.value.company.trim().replace(/\s\s+/g, ' ')));
    this.workExperienceForm.controls.description.setValue(String(this.workExperienceForm.value.description.trim().replace(/\s\s+/g, ' ')));
  }

  educationFilter(){
    this.educationalDetailsForm.controls.universityName.setValue(String(this.educationalDetailsForm.value.universityName.trim().replace(/\s\s+/g, ' ')));
    this.educationalDetailsForm.controls.degree.setValue(String(this.educationalDetailsForm.value.degree.trim().replace(/\s\s+/g, ' ')));
    this.educationalDetailsForm.controls.fieldOfStudy.setValue(String(this.educationalDetailsForm.value.fieldOfStudy.trim().replace(/\s\s+/g, ' ')));
    this.educationalDetailsForm.controls.instituteLocation.setValue(String(this.educationalDetailsForm.value.instituteLocation.trim().replace(/\s\s+/g, ' ')));
  }

  linksFilter(){
    this.profileLinksForm.controls.githubUrl.setValue(String(this.profileLinksForm.value.githubUrl.trim().replace(/\s\s+/g, ' ')));
    this.profileLinksForm.controls.linkedInUrl.setValue(String(this.profileLinksForm.value.linkedInUrl.trim().replace(/\s\s+/g, ' ')));
  }

  viewIncompleteMessage(){
    let value = localStorage.getItem("landing")
    if(value){
      this.showIncompleteMessage = true
    }
  }

  navigateToIncomplete(){
    switch(localStorage.getItem("landing")) {
      case 'SKILLS': { 
        this.scrollIntoElementView(this.skillsFormElement)
         break; 
      } 
      case 'BASIC': { 
        this.scrollIntoElementView(this.basicDetailsFormElement);
         break; 
      } 
      case 'WORK': { 
        this.scrollIntoElementView(this.workExperienceFormElement);
         break; 
      }
      case 'EDUCATION': { 
        this.scrollIntoElementView(this.educationalDetailsFormElement);
         break; 
      }
      case 'PREFERENCES': { 
        this.scrollIntoElementView(this.preferencesFormElement);
         break; 
      }
      case 'PROFILE': { 
        this.scrollIntoElementView(this.profileLinksFormElement);
         break; 
      }
      default: { 
         break; 
      } 
   }
   localStorage.removeItem("landing")
 }

  getCandidateDetails(){
    this.authService.getUserId().subscribe(
      (a) => {
        this.candidateService.getCandidateDetails(a.uid).subscribe(
          (a: CandidateData) => {
            console.log(a)
            if(a){
              this.candidate_data = a
              this.candidate_id = a._id;
              this.prefillValues(a)
            } else {
              this.candidate_data = JSON.parse(localStorage.getItem('user'))
              this.candidate_id = this.candidate_data._id;
              console.log(this.candidate_data)
              this.prefillValues(this.candidate_data)
            }
          }
        )
      }
    )
  }

  submitBasicDetailsForm() {
    for (const i in this.basicDetailsForm.controls) {
      this.basicDetailsForm.controls[i].markAsDirty();
      this.basicDetailsForm.controls[i].updateValueAndValidity();
    }
    if (this.basicDetailsForm.valid) {
      this.candidateService.setCandidateDetails({
        _id:this.candidate_id,
        profile: {
          first_name: this.basicDetailsForm.value.firstName,
          last_name: this.basicDetailsForm.value.lastName,
          email_id: this.basicDetailsForm.value.email ? this.basicDetailsForm.value.email: this.candidate_data.profile.email_id,
          mobile: this.basicDetailsForm.value.mobileNumber,
          address: this.basicDetailsForm.value.location,
          profile_image_url: this.basicDetailsForm.value.profileImage ? this.basicDetailsForm.value.profileImage: this.profile_url
        },
        resume: {
          work_experience: this.workExperience,
          linkedinUrl: this.profileLinksForm.value.linkedInUrl,
          githubUrl: this.profileLinksForm.value.githubUrl,
          headline: this.basicDetailsForm.value.headline,
          interest: this.basicDetailsForm.value.isActivelyLooking,
          job_type: {
            name: this.skillsForm.value.jobType,
            total_experience: this.skillsForm.value.totalExperience,
          },
          job_roles: this.createJobRolesArray(),
          skills: {
            primarySkills: this.skillsForm.value.primarySkills,
            additionalSkills: this.skillsForm.value.additionalSkills
          },
          education_details: this.educationalDetails,
          preferences: {
            preferred_location: this.preferencesForm.value.preferredLocation,
            any_state_in_usa: this.preferencesForm.value.anyStateInUsa,
            employement_types: {
              full_time: this.preferencesForm.value.fullTime,
              internship: this.preferencesForm.value.internship,
              contractor: this.preferencesForm.value.contractor,
            }
          }
        }
      }).subscribe(
        (a) => {
          console.log(a);
          this.scrollIntoElementView(this.skillsFormElement)
        }
      )
    }
  }

  addWorkExperienceForm(e) {
    // console.log(e)
    // e.preventDefault();
    for (const i in this.workExperienceForm.controls) {
      this.workExperienceForm.controls[i].markAsDirty();
      this.workExperienceForm.controls[i].updateValueAndValidity();
    }
    if (this.workExperienceForm.valid) {
      console.log(this.workExperienceForm.value)
      if(!this.editWorkExperience.flag){
        this.workExperience.push({
          company: this.workExperienceForm.value.company,
          start_date: this.workExperienceForm.value.isCurrentlyWorking ? this.workExperienceForm.value.startDate : this.workExperienceForm.value.duration[0],
          end_date: this.workExperienceForm.value.isCurrentlyWorking ? null : this.workExperienceForm.value.duration[1],
          title: this.workExperienceForm.value.title,
          description: this.workExperienceForm.value.description
        })
        //sort
        this.workExperience.sort((a, b) => new Date(b.start_date).getTime() - new Date(a.start_date).getTime());
        console.log("sort:",this.workExperience)     
      } else {
        this.workExperience[this.editWorkExperience.index] = {
          company: this.workExperienceForm.value.company,
          start_date: this.workExperienceForm.value.isCurrentlyWorking ? this.workExperienceForm.value.startDate : this.workExperienceForm.value.duration[0],
          end_date: this.workExperienceForm.value.isCurrentlyWorking ? null : this.workExperienceForm.value.duration[1],
          title: this.workExperienceForm.value.title,
          description: this.workExperienceForm.value.description
        }
        this.editWorkExperience.flag = false;
        this.editWorkExperience.index = null;
      }
      this.workExperienceForm.reset();
      this.calculateExp();  
    }
  }

  submitWorkExperienceForm() {
    if (this.workExperience.length > 0) {
      this.candidateService.setCandidateDetails({
        _id:this.candidate_id,
        resume: {
          work_experience: this.workExperience,
          linkedinUrl: this.profileLinksForm.value.linkedInUrl,
          githubUrl: this.profileLinksForm.value.githubUrl,
          headline: this.basicDetailsForm.value.headline,
          interest: this.basicDetailsForm.value.isActivelyLooking,
          job_type: {
            name: this.skillsForm.value.jobType,
            total_experience: this.skillsForm.value.totalExperience,
          },
          job_roles: this.createJobRolesArray(),
          skills: {
            primarySkills: this.skillsForm.value.primarySkills,
            additionalSkills: this.skillsForm.value.additionalSkills
          },
          education_details: this.educationalDetails,
          preferences: {
            preferred_location: this.preferencesForm.value.preferredLocation,
            any_state_in_usa: this.preferencesForm.value.anyStateInUsa,
            employement_types: {
              full_time: this.preferencesForm.value.fullTime,
              internship: this.preferencesForm.value.internship,
              contractor: this.preferencesForm.value.contractor,
            }
          }
        }
      }).subscribe(
        (a) => {
          console.log(a);
          this.scrollIntoElementView(this.educationalDetailsFormElement)
        }
      )
    }
    else {
      this._snackBar.open('Add work experience!', 'Okay', {
        duration: 5000,
        });
    }
  }

  createJobRolesArray() {
    let rolesArray = [];
    for (let x in this.jobRoleExperienceList) {
      if (this.jobRoleExperienceList[x].selected) {
        rolesArray.push(this.jobRoleExperienceList[x]);
      }
    }
    return rolesArray;
  }

  submitSkills(e) {
    e.preventDefault();
    for (const i in this.skillsForm.controls) {
      this.skillsForm.controls[i].markAsDirty();
      this.skillsForm.controls[i].updateValueAndValidity();
    }
    console.log(this.skillsForm.value)
    this.candidateService.setCandidateDetails({
      _id:this.candidate_id,
      resume: {
        work_experience: this.workExperience,
        linkedinUrl: this.profileLinksForm.value.linkedInUrl,
        githubUrl: this.profileLinksForm.value.githubUrl,
        headline: this.basicDetailsForm.value.headline,
        interest: this.basicDetailsForm.value.isActivelyLooking,
        job_type: {
          name: this.skillsForm.value.jobType,
          total_experience: this.skillsForm.value.totalExperience,
        },
        job_roles: this.createJobRolesArray(),
        skills: {
          primarySkills: this.skillsForm.value.primarySkills,
          additionalSkills: this.skillsForm.value.additionalSkills
        },
        education_details: this.educationalDetails,
        preferences: {
          preferred_location: this.preferencesForm.value.preferredLocation,
          any_state_in_usa: this.preferencesForm.value.anyStateInUsa,
          employement_types: {
            full_time: this.preferencesForm.value.fullTime,
            internship: this.preferencesForm.value.internship,
            contractor: this.preferencesForm.value.contractor,
          }
        }
      }
    }).subscribe(
      (a) => {
        console.log(a);
        this.scrollIntoElementView(this.workExperienceFormElement)
      }
    )
  }

  addEducationDetails(e) {
    console.log(e)
    e.preventDefault();
    for (const i in this.educationalDetailsForm.controls) {
      this.educationalDetailsForm.controls[i].markAsDirty();
      this.educationalDetailsForm.controls[i].updateValueAndValidity();
    }
    if (this.educationalDetailsForm.valid) {
      console.log(this.educationalDetailsForm.value)
      if(!this.editEducationDetails.flag){
        this.educationalDetails.push({
          degree: this.educationalDetailsForm.value.degree,
          field_of_study: this.educationalDetailsForm.value.fieldOfStudy,
          university: this.educationalDetailsForm.value.universityName,
          institute_location: this.educationalDetailsForm.value.instituteLocation,
          graduationYear: this.educationalDetailsForm.value.graduationYear
        })
      } else {
        this.educationalDetails[this.editEducationDetails.index] = {
          degree: this.educationalDetailsForm.value.degree,
          field_of_study: this.educationalDetailsForm.value.fieldOfStudy,
          university: this.educationalDetailsForm.value.universityName,
          institute_location: this.educationalDetailsForm.value.instituteLocation,
          graduationYear: this.educationalDetailsForm.value.graduationYear
        }
        this.editEducationDetails.flag = false;
        this.editEducationDetails.index = null;
      }

      this.educationalDetailsForm.reset();
      console.log("array: ", this.educationalDetails)
    }
  }

  submitEducationalDetails() {
    console.log("submiting.. ")
    if (this.educationalDetails.length > 0) {
      console.log("updating in db..")
      this.candidateService.setCandidateDetails({
        _id:this.candidate_id,
        resume: {
          work_experience: this.workExperience,
          linkedinUrl: this.profileLinksForm.value.linkedInUrl,
          githubUrl: this.profileLinksForm.value.githubUrl,
          headline: this.basicDetailsForm.value.headline,
          interest: this.basicDetailsForm.value.isActivelyLooking,
          job_type: {
            name: this.skillsForm.value.jobType,
            total_experience: this.skillsForm.value.totalExperience,
          },
          job_roles: this.createJobRolesArray(),
          skills: {
            primarySkills: this.skillsForm.value.primarySkills,
            additionalSkills: this.skillsForm.value.additionalSkills
          },
          education_details: this.educationalDetails,
          preferences: {
            preferred_location: this.preferencesForm.value.preferredLocation,
            any_state_in_usa: this.preferencesForm.value.anyStateInUsa,
            employement_types: {
              full_time: this.preferencesForm.value.fullTime,
              internship: this.preferencesForm.value.internship,
              contractor: this.preferencesForm.value.contractor,
            }
          }
        }
      }).subscribe(
        (a) => {
          console.log("data: ")
          console.log(a);
          this.scrollIntoElementView(this.preferencesFormElement)
        }
      )
    }
    else {
      this._snackBar.open('Add educational details!', 'Okay', {
        duration: 5000,
        });
    }
  }

  submitPreferencesForm() {
    for (const i in this.preferencesForm.controls) {
      console.log(this.preferencesForm.controls[i])
      this.preferencesForm.controls[i].markAsDirty();
      this.preferencesForm.controls[i].updateValueAndValidity();
      console.log(this.preferencesForm.controls[i]['controls'])
      if (this.preferencesForm.controls[i]['controls']) {
        console.log('condition satisfied')
        for (let x in this.preferencesForm.controls[i]['controls']) {
          let form = this.preferencesForm.controls[i]['controls'][x] as FormControl;
          console.log('now looping', form)
          form.markAsDirty();
          form.updateValueAndValidity();
        }
      }
    }
    console.log(this.preferencesForm.value)
    this.candidateService.setCandidateDetails({
      _id:this.candidate_id,
      resume: {
        work_experience: this.workExperience,
        linkedinUrl: this.profileLinksForm.value.linkedInUrl,
        githubUrl: this.profileLinksForm.value.githubUrl,
        headline: this.basicDetailsForm.value.headline,
        interest: this.basicDetailsForm.value.isActivelyLooking,
        job_type: {
          name: this.skillsForm.value.jobType,
          total_experience: this.skillsForm.value.totalExperience,
        },
        job_roles: this.createJobRolesArray(),
        skills: {
          primarySkills: this.skillsForm.value.primarySkills,
          additionalSkills: this.skillsForm.value.additionalSkills
        },
        education_details: this.educationalDetails,
        preferences: {
          preferred_location: this.preferencesForm.value.preferredLocation,
          any_state_in_usa: this.preferencesForm.value.anyStateInUsa,
          employement_types: {
            full_time: this.preferencesForm.value.fullTime,
            internship: this.preferencesForm.value.internship,
            contractor: this.preferencesForm.value.contractor,
          }
        }
      }
    }).subscribe(
      (a) => {
        console.log(a);
        this.scrollIntoElementView(this.profileLinksFormElement
        )
      }
    )
  }

  submitProfileLinks() {
    for (const i in this.profileLinksForm.controls) {
      this.profileLinksForm.controls[i].markAsDirty();
      this.profileLinksForm.controls[i].updateValueAndValidity();
    }
    if(this.basicDetailsForm.valid && this.workExperience.length && this.educationalDetails.length){
      //console.log("inside", this.basicDetailsForm.value)
      this.candidateService.setCandidateDetails({
        _id:this.candidate_id,
        resume: {
          work_experience: this.workExperience,
          linkedinUrl: this.profileLinksForm.value.linkedInUrl,
          githubUrl: this.profileLinksForm.value.githubUrl,
          headline: this.basicDetailsForm.value.headline,
          interest: this.basicDetailsForm.value.isActivelyLooking,
          job_type: {
            name: this.skillsForm.value.jobType,
            total_experience: this.skillsForm.value.totalExperience,
          },
          job_roles: this.createJobRolesArray(),
          skills: {
            primarySkills: this.skillsForm.value.primarySkills,
            additionalSkills: this.skillsForm.value.additionalSkills
          },
          education_details: this.educationalDetails,
          preferences: {
            preferred_location: this.preferencesForm.value.preferredLocation,
            any_state_in_usa: this.preferencesForm.value.anyStateInUsa,
            employement_types: {
              full_time: this.preferencesForm.value.fullTime,
              internship: this.preferencesForm.value.internship,
              contractor: this.preferencesForm.value.contractor,
            }
          }
        }
      }).subscribe(
        (a) => {
          console.log(a);
            this._snackBar.open('Profile submitted successully!', 'Okay', {
            duration: 5000,
            });
          this.router.navigateByUrl("/dashboard")
        },
        (error) =>{
          this._snackBar.open('Error! Could not submit profile', 'Okay', {
            duration: 5000,
            });
        }
      )
    }
    else{
      this._snackBar.open('Please fill all the fields', 'Okay', {
        duration: 5000,
        });
    }
  }

  getJobTypes() {
    this.candidateService.getJobTypes().subscribe(
      (a: any) => {
        console.log(a)
        this.jobTypes = a;
      }
    )
  }

  getJobRoles(event) {
    console.log(event)
    this.candidateService.getJobRoles(this.skillsForm.value.jobType).subscribe(
      (a) => {
        console.log(a)
        this.jobRoleExperienceList = []
        for (let x in a) {
          let obj = {
            jobRole: a[x]['name'],
            experience: null,
            selected: false
          }
          this.jobRoleExperienceList.push(obj)
        }
        console.log(this.jobRoleExperienceList)
      }
    )
  }

  scrollIntoElementView(element) {
    element.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  fileChange(type, event) {
    if (type == 'profile') {
      this.file = event.target.files[0];
      var filename = Date.now();
      const filePath = 'profile_images/' + filename;
      const task = this.storage.upload(filePath, this.file).snapshotChanges().subscribe(
        (a) => {
          a.ref.getDownloadURL().then(
            (url) => {
              console.log(url);
              this.basicDetailsForm.value.profileImage = url;
              this.profile_url = url;
            }
          )
        }
      );
    }
    else if (type == 'resume') {
      this.file = event.target.files[0];
      var filename = Date.now();
      const filePath = 'resumes/' + filename;
      const task = this.storage.upload(filePath, this.file).snapshotChanges().subscribe(
        (a) => {
          a.ref.getDownloadURL().then(
            (url) => {
              this.resumeForm.value.resumeUrl = url;
              console.log(url)
            }
          )
        }
      );
    }
  }

  workExperienceEdit(idx){
    console.log(idx)
    this.editWorkExperience.index=idx
    this.editWorkExperience.flag = true
    let experience = this.workExperience[idx]
    experience['duration'] = [experience.start_date,experience.end_date]
    experience['isCurrentlyWorking'] = experience.end_date ? false : true;
    experience['startDate'] = experience.start_date
    delete experience['end_date']
    delete experience['start_date']
    this.workExperienceForm.setValue(experience)
  }

  workExperienceDelete(idx){
    this.workExperience.splice(idx,1);
  }

  educationDetailsEdit(idx){
    console.log(idx)
    this.editEducationDetails.index=idx
    this.editEducationDetails.flag = true
    let education = {}
    education['degree'] = this.educationalDetails[idx].degree;
    education['fieldOfStudy'] = this.educationalDetails[idx].field_of_study;
    education['universityName'] = this.educationalDetails[idx].university;
    education['instituteLocation'] = this.educationalDetails[idx].institute_location;
    education['graduationYear'] = this.educationalDetails[idx].graduationYear;
    this.educationalDetailsForm.setValue(education)
  }

  educationDetailsDelete(idx){
    this.educationalDetails.splice(idx,1);
  }

  addPreferenceLocations(value){
    console.log(value);
    this.candidateService.updatePreferenceLocations(value);
  }




  openPdf() {
    window.open(this.resumeForm.value.resumeUrl, '_blank');
  }

  changePdf() {
    this.resumeForm.value.resumeUrl = null;
  }

  getLocations(value) {
    if(value){
      this.candidateService.getLocations(value).subscribe(
        (a: any) => {
          this.filterlocations = [];
          let data = a.predictions;
          data.forEach(
            (q) => {
              this.filterlocations.push(q.terms[q.terms.length - 3].value + ', ' + q.terms[q.terms.length - 2].value);
            }
          )
        }
      )
    }
  }

  prefillValues(data){
    this.basicDetailsForm.controls.firstName.setValue(data.profile.first_name)
    this.basicDetailsForm.controls.lastName.setValue(data.profile.last_name)
    this.basicDetailsForm.controls.email.setValue(data.profile.email_id)
    this.basicDetailsForm.controls.mobileNumber.setValue(data.profile.mobile)
    this.basicDetailsForm.controls.location.setValue(data.profile.address)
    this.basicDetailsForm.controls.profileImage.setValue(data.profile.profile_image_url)
    this.profile_url = data.profile.profile_image_url
    if(data.resume){
      this.basicDetailsForm.controls.headline.setValue(data.resume.headline)
      this.basicDetailsForm.controls.isActivelyLooking.setValue(data.resume.interest)
      this.profileLinksForm.controls.linkedInUrl.setValue(data.resume.linkedinUrl)
      this.profileLinksForm.controls.githubUrl.setValue(data.resume.githubUrl)
      this.educationalDetails = data.resume.education_details
      this.workExperience = data.resume.work_experience
      this.calculateExp();
      if(data.resume.job_type){
        this.skillsForm.controls.jobType.setValue(data.resume.job_type.name)
        this.skillsForm.controls.totalExperience.setValue(data.resume.job_type.total_experience)
        this.getJobRoles(null)
      }
      if(data.resume.skills){
        this.skillsForm.controls.primarySkills.setValue(data.resume.skills.primarySkills)
        this.skillsForm.controls.additionalSkills.setValue(data.resume.skills.additionalSkills)
      }
      if(data.resume.preferences){
        this.preferencesForm.controls.preferredLocation.setValue(data.resume.preferences.preferred_location)
        this.preferencesForm.controls.anyStateInUsa.setValue(data.resume.preferences.any_state_in_usa)
        if(data.resume.preferences.employement_types){
          this.preferencesForm.controls.fullTime.setValue(data.resume.preferences.employement_types.full_time)
          this.preferencesForm.controls.internship.setValue(data.resume.preferences.employement_types.internship)
          this.preferencesForm.controls.contractor.setValue(data.resume.preferences.employement_types.contractor)
        }
      }
      setTimeout(()=>{                           
        if(data.resume.job_roles){
          console.log(data.resume.job_roles)
          let job_roles = data.resume.job_roles
          for(let idx in job_roles){
            for (let x in this.jobRoleExperienceList) {
              if (this.jobRoleExperienceList[x].jobRole == job_roles[idx].jobRole) {
                this.jobRoleExperienceList[x] = job_roles[idx]
                this.jobRoleExperienceList[x].selected = true
              }
            }
          }
          console.log(this.jobRoleExperienceList)
        }
        this.navigateToIncomplete()
      }, 2000);
    }
    
  }

  calculateExp(){
    //calculate duration in yr,month
    var first_date: Date;
    var second_date: Date;
    var day = 1000 * 60 * 60 * 24;
    var month: number;
    var year: number;
    var diff: any;
    for (let i in this.workExperience) {
      first_date = new Date(this.workExperience[i].start_date);
      if (this.workExperience[i].end_date) {
        second_date = new Date(this.workExperience[i].end_date);
      }else{
        second_date = new Date();
      }
      diff = Math.floor(second_date.getTime() - first_date.getTime());
      month = Math.floor((diff / day) / 31) 
      while(month > 12){
        month = month - 12;
      }
      year = Math.floor(((diff / day) / 31 / 12));
      this.no_experience[i] = "(" + year + " yrs" + ", " + month + " mos)";
    }
  }
}